// Registra globalmente todo .vue de pages/ y components/, con el nombre del
// archivo: pages/Home.vue -> <Home>, components/ui/DataTable.vue -> <DataTable>.
// Basta con crear el archivo para poder usarlo desde cualquier vista ERB.
//
//   pages/       componentes de página, uno por vista de Rails
//   components/  piezas reutilizables que las páginas componen
//
// Cada componente se registra dos veces a propósito. Los templates viven en el
// DOM que renderiza ERB, y el navegador baja el nombre de la etiqueta a
// minúsculas antes de que Vue lo vea, así que <UserCard> llega como <usercard>.
// Vue resuelve eso probando "usercard", "userCard" y "Usercard" — ninguno es
// "UserCard". El alias en minúsculas cierra ese hueco, de modo que en el ERB
// funcionan tanto <UserCard> como <user-card>.

const modules = {
  ...import.meta.glob('./pages/**/*.vue', { eager: true }),
  ...import.meta.glob('./components/**/*.vue', { eager: true })
}

export default function registerComponents(app) {
  const seen = new Map()

  for (const [path, module] of Object.entries(modules)) {
    const name = path.split('/').pop().replace(/\.vue$/, '')

    for (const alias of new Set([ name, name.toLowerCase() ])) {
      const previous = seen.get(alias)
      if (previous) {
        throw new Error(
          `Vue component name clash: ${path} y ${previous} resuelven ambos a "${alias}". ` +
          'Los nombres de archivo deben ser únicos ignorando mayúsculas.'
        )
      }

      seen.set(alias, path)
      app.component(alias, module.default)
    }
  }
}
